import { BottomNavigation, BottomNavigationAction, Stack, Switch } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React, {
	FunctionComponent,
	useCallback,
	useEffect,
	useMemo,
	useState,
} from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { useErrorHandlerInterceptor } from '../../interceptors';
import { useTranslation } from '../../services';
import ResponseResultAlert from '../ResponseResultAlert/ResponseResultAlert';
import WithGlobalServices from '../WithGlobalServices';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ukUA } from '@mui/material/locale';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { LocalizationProvider } from '@mui/x-date-pickers';

const Layout: FunctionComponent<any> = ({ children }) => {
	const [mode, setMode] = useState<'light' | 'dark'>(
		(localStorage.getItem('mode') as any) || 'dark'
	);
	const { t, setLang, lang } = useTranslation();
	useErrorHandlerInterceptor();
	const [value, setValue] = useState(0);

	const toggleMode = useCallback(() => {
		mode === 'light' ? setMode('dark') : setMode('light');
	}, [mode, setMode]);

	const theme = useMemo(
		() =>
			createTheme({
				palette: {
					mode,
				},
			}),
		[mode]
	);

	const themeWithLocale = React.useMemo(() => createTheme(theme, ukUA), [theme]);

	useEffect(() => {
		switch (value) {
			case 0:
				setLang('uk');
				break;
			case 1:
				setLang('en');
				break;
		}
	}, [value]);

	useEffect(() => {
		localStorage.setItem('mode', mode);
	}, [mode]);

	return (
		<>
			<ThemeProvider theme={themeWithLocale}>
				<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={lang}>
					<CssBaseline>
						<ResponseResultAlert />
						{children}
						<Stack
							component="div"
							direction="row"
							sx={{ w: '100%', mt: 3 }}
							justifyContent="center"
						>
							<BottomNavigation
								showLabels
								value={value}
								onChange={(event, newValue) => {
									setValue(newValue);
								}}
							>
								<BottomNavigationAction label="Українська" />
								<BottomNavigationAction label="English" />
							</BottomNavigation>
							<Stack direction="row" alignItems="center">
								<Brightness7Icon />
								<Switch
									checked={mode === 'dark'}
									title={t('switch day/night')}
									onChange={toggleMode}
								/>
								<Brightness4Icon />
							</Stack>
						</Stack>
					</CssBaseline>
				</LocalizationProvider>
			</ThemeProvider>
		</>
	);
};

export default WithGlobalServices(Layout);
